export default __webpack_public_path__ + "static/N0173-488c9a3034614ec73a84cdb999eb97c6.png";